var _path, _path2, _path3, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.36667L6.5 3.03334",
    stroke: "#01021D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.15L9.96667 9.75",
    stroke: "#01021D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49987 7.15L3.0332 9.75",
    stroke: "#01021D",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.83325,
    y: 0.530884,
    width: 3.33333,
    height: 3.33333,
    rx: 0.5,
    fill: "#01021D",
    stroke: "#01021D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.16675,
    y: 9.19757,
    width: 3.33333,
    height: 3.33333,
    rx: 0.5,
    fill: "#01021D",
    stroke: "#01021D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 9.19745,
    width: 3.33333,
    height: 3.33333,
    rx: 0.5,
    fill: "#01021D",
    stroke: "#01021D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnchain);
export default __webpack_public_path__ + "static/media/onchain.c5fd7e2ba1e413359cbec64368342d4a.svg";
export { ForwardRef as ReactComponent };